import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import {
    DialogContent,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import List from "@mui/material/List";
import PropTypes from "prop-types";
import * as React from "react";
import useCheckMobileScreen from '../../utils/detect-mobile-size';

export default function PaymentMethodModal(props: { onClose: any; open: any; selectedValue?: any; method: any; setMethod: any; }) {
    const { onClose, open, selectedValue, method, setMethod } = props;
    const paymentMethods = ["iDeal", "Credit Card", "PayPal", "Apple Pay"];

    let isMobile = useCheckMobileScreen();

    const handleSelectedMethod = (method: any) => {
        setMethod(method);
        handleClose();
    }

    const handleClose = () => {
        onClose(selectedValue);
    };

    return (
        <Dialog PaperProps={{ style: { borderRadius: !isMobile ? "1.5rem" : "" } }} fullScreen={isMobile} onClose={handleClose} open={open} fullWidth={true}>
            <DialogTitle>Betaalmethode
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
            <DialogContent>
                <div className="flex flex-col space-y-4 h-full pb-8">
                    {paymentMethods.map((e, i) =>
                        <button onClick={() => handleSelectedMethod(e)} key={i} className="payment-option">
                            {e}
                        </button>
                    )}
                </div>
            </DialogContent>

        </Dialog>
    );
}
PaymentMethodModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};